<ng-container *transloco="let t">
  <div [formGroup]="form" class="owner-statement-debt-installments">
    <h3 class="mb-2">
      {{ t('Statement of Debt Acceptance and Installment Payment') }}
    </h3>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('Total amount') }}</mat-label>
      <input matInput formControlName="totalAmount" />
    </mat-form-field>

    <div class="grid grid-cols-2 gap-3">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ t('Period from') }}</mat-label>
        <input
          matInput
          [matDatepicker]="pickerFrom"
          formControlName="periodFrom"
        
          [min]="minDate"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="pickerFrom"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ t('Period to') }}</mat-label>
        <input matInput [matDatepicker]="pickerTo" formControlName="periodTo" 
          [min]="minDate"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="pickerTo"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerTo></mat-datepicker>
      </mat-form-field>
    </div>

    @if (
      form.errors?.periodRangeInvalid &&
      (form.get('periodFrom')?.touched || form.get('periodTo')?.touched)
    ) {
      <div class="text-error mt-1">
        {{ t('Period from must not be later than Period to') }}
      </div>
    }

    <mat-form-field appearance="outline" class="w-full mb-3 mt-3">
      <mat-label>{{ t('Number of installments') }}</mat-label>
      <input type="number" matInput formControlName="numberOfInstallments" />
    </mat-form-field>

    <div class="installments-list" formArrayName="installments">
      @for (inst of installments.controls; track i; let i = $index) {
        <div [formGroupName]="i" class="installment-row mb-2">
          <div class="installment-header">
            {{ t('Installment') }} {{ inst.get('installmentNumber')?.value }}
          </div>
          <div class="grid grid-cols-3 gap-3 items-end">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{ t('Amount') }}</mat-label>
              <input matInput formControlName="amount" />
              @if (
                i === installments.length - 1 &&
                remainingAmount !== null &&
                !inst.get('amount')?.value
              ) {
                <mat-hint>{{ t('Remaining') }}: {{ remainingAmount }}</mat-hint>
              }
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{ t('Date') }}</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="date" 
          [min]="minDate"
        />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <div class="actions">
              <button mat-icon-button
                class="btn-delete"
                type="button"
                (click)="removeInstallment(i)" aria-label="Icon button">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>

          @if (
            inst.errors?.dateRequiredForAmount &&
            (inst.get('amount')?.touched || inst.get('date')?.touched)
          ) {
            <div class="text-error mt-1">
              {{ t('Installment date required when amount entered') }}
            </div>
          }
        </div>
      }
      @if (canAddInstallment) {
        <div class="mt-2">
          <button mat-stroked-button type="button" (click)="addInstallment()">
            {{ t('Add installment') }}
          </button>
        </div>
      }
    </div>

    @if (form.errors?.installmentSumMismatch) {
      <div class="text-error mt-1 mb-2">
        {{ t('The sum of installment amounts must equal the total amount') }}
      </div>
    }

    <div class="grid grid-cols-2 gap-3 mt-4 mb-3">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ t('Created date') }}</mat-label>
        <input
          matInput
          [matDatepicker]="pickerCreated"
          formControlName="createdDate"
        
          [min]="minDate"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="pickerCreated"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerCreated></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ t('Total debt') }}</mat-label>
        <input matInput formControlName="totalDebt" />
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('Note') }}</mat-label>
      <textarea matInput formControlName="note" rows="4"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput formControlName="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
